import * as React from 'react';
import "./whiteSkyHeader.less";

export interface WhiteSkyHeaderProps {
}

export const WhiteSkyHeader = (props: WhiteSkyHeaderProps) => {


    const { } = props;


    return <div className="white-sky-header">
        <a href="https://whitesky.com.au/">
            {/* <img src="/assets/ws-logo-sm.png" /> */}
            <img src="/assets/WSK_Logo WHITE2.png" />
        </a>

        {/* taken from whitesky website */}
        <div className="menu-box" >
            {/* <nav> */}
            <ul id="menu-main-menu" className="primary-menu sf-menu clearfix">
                <li id="menu-item-703" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-parent-item menu-first-level-item menu-item-703"><a href="https://whitesky.com.au/services/">SERVICES</a>
                </li>
                <li id="menu-item-702" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-parent-item menu-first-level-item menu-item-702"><a href="https://whitesky.com.au/clients/">CLIENTS</a>
                </li>
                <li id="menu-item-1366" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-parent-item menu-first-level-item menu-item-1366"><a href="https://whitesky.com.au/about-white-sky/">ABOUT</a>
                </li>
                <li id="menu-item-17" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-parent-item menu-first-level-item menu-item-17"><a href="https://whitesky.com.au/contact/">CONTACT</a>
                </li>
            </ul>
            {/* </nav> */}
        </div>




    </div>

}